"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _loadingSpinner = _interopRequireDefault(require("./icons/loading-spinner.svg"));

var _constants = require("libs/constants");

var _common = require("@insided/shared/utils/common");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

// non capitalized class names are from CKEditor
// so we disable this rule for the entire file

/* eslint-disable new-cap */
var uniqueNameCounter = 0;
var WIDGET_NAME = 'insidedimage';

function padNumber(input) {
  if (input <= 9) {
    input = '0' + input;
  }

  return String(input);
}

function getUniqueImageFileName(type) {
  var date = new Date();
  var dateParts = [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()];
  uniqueNameCounter += 1;
  return 'image-' + window.CKEDITOR.tools.array.map(dateParts, padNumber).join('') + '-' + uniqueNameCounter + '.' + type;
}

function isEmailEditor(profile) {
  return profile === 'email';
}

var isImageResizingEnabled = _common.common.isModuleActive('imageResizingAndAlignment');

function isControl(environment) {
  return environment === _constants.env.CONTROL;
}

var imageUploadPlugin = {
  requires: 'uploadwidget,cloudservices,clipboard,imagebase,notification',
  isSupportedEnvironment: function isSupportedEnvironment(CKEDITOR) {
    return CKEDITOR.plugins.clipboard.isFileApiSupported;
  },
  onLoad: function onLoad() {
    window.CKEDITOR.addCss('.cke_image_nocaption{' + // This is to remove unwanted space so resize
    // wrapper is displayed property.
    'line-height:0' + '}' + '.cke_editable.cke_image_sw, .cke_editable.cke_image_sw *{cursor:sw-resize !important}' + '.cke_editable.cke_image_se, .cke_editable.cke_image_se *{cursor:se-resize !important}' + '.cke_image_resizer{' + 'display:none;' + 'position:absolute;' + 'width:10px;' + 'height:10px;' + 'bottom:-5px;' + 'right:-5px;' + 'background:#000;' + 'outline:1px solid #fff;' + // Prevent drag handler from being misplaced (https://dev.ckeditor.com/ticket/11207).
    'line-height:0;' + 'cursor:se-resize;' + '}' + '.cke_image_resizer_wrapper{' + 'position:relative;' + 'display:inline-block;' + 'line-height:0;' + '}' + // Bottom-left corner style of the resizer.
    '.cke_image_resizer.cke_image_resizer_left{' + 'right:auto;' + 'left:-5px;' + 'cursor:sw-resize;' + '}' + '.cke_widget_wrapper:hover .cke_image_resizer,' + '.cke_image_resizer.cke_image_resizing{' + 'display:block' + '}' + // Hide resizer in read only mode (#2816).
    '.cke_editable[contenteditable="false"] .cke_image_resizer{' + 'display:none;' + '}' + // Expand widget wrapper when linked inline image.
    '.cke_widget_wrapper>a{' + 'display:inline-block' + '}');
  },
  init: function init(editor) {
    var imageCountsToProcess = 0;
    var CKEDITOR = window.CKEDITOR;

    if (!this.isSupportedEnvironment(CKEDITOR)) {
      return;
    }

    var config = editor.config;
    var fileTools = CKEDITOR.fileTools;
    var figureClass = config.easyimage_class;
    editor.ui.addButton('ImageUpload', {
      label: editor.lang.common.image,
      command: 'easyimageUpload',
      toolbar: 'insert,1'
    });
    editor.addCommand('easyimageUpload', {
      exec: function exec() {
        var hiddenUploadElement = CKEDITOR.dom.element.createFromHtml('<input type="file" accept="image/*" multiple="multiple">');
        hiddenUploadElement.once('change', function (evt) {
          var targetElement = evt.data.getTarget();
          var isNotificationShown = false;
          if (!targetElement.$.files.length) return;
          var files = [];
          var supportedImageTypes = /image\/(jpeg|png|gif|bmp|webp)/;
          var isFileTypeErrorShown = false;

          for (var i = 0; i < targetElement.$.files.length; i++) {
            var file = targetElement.$.files[i];
            var isSupportedType = supportedImageTypes.test(file.type);

            if (!isSupportedType && !isFileTypeErrorShown) {
              isFileTypeErrorShown = true;
              var notification = new CKEDITOR.plugins.notification(editor, {
                category: 'Common',
                phrase: 'js.uploader.error_file_type',
                message: 'File type is not supported',
                shouldShow: true
              });
              notification.show();
            }

            var isCorrectSize = file.size < _constants.maxImageFileSize;

            if (!isCorrectSize && !isNotificationShown) {
              isNotificationShown = true;

              var _notification = new CKEDITOR.plugins.notification(editor, {
                category: 'Common',
                phrase: 'js.uploader.error_file_size',
                message: 'Image is too big',
                shouldShow: true
              });

              _notification.show();
            }

            if (isCorrectSize && isSupportedType) files.push(file);
          }

          if (!files) return;
          editor.fire('paste', {
            method: 'paste',
            dataValue: '',
            dataTransfer: new CKEDITOR.plugins.clipboard.dataTransfer({
              files: files
            })
          });
        });
        hiddenUploadElement.$.click();
      }
    });

    function ProgressBar() {
      CKEDITOR.plugins.imagebase.progressReporter.call(this, "<div class=\"loading-backdrop\">".concat(_loadingSpinner.default, "</div>"));
    }

    ProgressBar.prototype = new CKEDITOR.plugins.imagebase.progressReporter();

    ProgressBar.prototype.bindLoader = function (loader) {
      var progressListeners = [];

      function removeProgressListeners() {
        if (progressListeners) {
          CKEDITOR.tools.array.forEach(progressListeners, function (listener) {
            listener.removeListener();
          });
          progressListeners = null;
        }
      }

      var updateListener = CKEDITOR.tools.eventsBuffer(100, function () {
        if (loader.uploadTotal) {
          this.updated(loader.uploaded / loader.uploadTotal);
        }
      }, this);
      progressListeners.push(loader.on('update', updateListener.input, this));
      progressListeners.push(loader.once('abort', this.aborted, this));
      progressListeners.push(loader.once('download', this.done, this));
      progressListeners.push(loader.once('error', this.failed, this));
      progressListeners.push(loader.once('abort', removeProgressListeners));
      progressListeners.push(loader.once('download', removeProgressListeners));
      progressListeners.push(loader.once('error', removeProgressListeners));
    };

    var widgetDefinition = {
      preloadImg: function preloadImg(loader, cb) {
        var tempImgThatLoadsData = new CKEDITOR.dom.element('img');
        tempImgThatLoadsData.setAttribute('src', loader.responseData.url);
        if (tempImgThatLoadsData.complete) return cb();
        tempImgThatLoadsData.once('load', cb);
      },
      init: function init() {
        var _this = this;

        this.on('uploadDone', function (evt) {
          var loader = evt.data.loader;

          _this.wrapper.addClass('cke_widget_wrapper_uploading');

          _this.preloadImg(loader, function () {
            _this.parts.image.setAttribute('src', loader.responseData.url);

            _this.wrapper.removeClass('cke_widget_wrapper_uploading');

            if (isEmailEditor(config.profile)) _this.element.findOne('figcaption').remove();
            loader.fire('download');
            editor.fire('change');
          });
        });
        this.on('uploadFailed', function (evt) {
          if (evt.data.loader.file.size > _constants.maxImageFileSize) return; //  failed because of size

          var notification = new CKEDITOR.plugins.notification(editor, {
            category: 'Common',
            phrase: 'js.uploader.error_on_upload',
            message: 'Image is too big',
            shouldShow: true
          });
          notification.show();
        });

        if (isImageResizingEnabled && isControl(config.environment)) {
          setupResizer(this); // Integrate with align commands (justify plugin).

          var align = {
            left: 1,
            right: 1,
            center: 1,
            block: 1
          };
          var integrate = alignCommandIntegrator(editor);

          for (var value in align) {
            integrate(value);
          }

          this.setData('align', this.element.getAttribute('align'));
          this.element.removeAttribute('align');
          this.on('data', function () {
            setWrapperAlign(this);
          });
        }
      },
      name: WIDGET_NAME,
      allowedContent: {
        figure: {
          classes: ['image', 'image-loading']
        },
        img: {
          attributes: '!src,srcset,alt,width,sizes'
        }
      },
      requiredContent: 'figure img[!src]',
      styleableElements: 'figure',
      supportedTypes: /image\/(jpeg|png|gif|bmp|webp)/,
      loaderType: CKEDITOR.plugins.cloudservices.cloudServicesLoader,
      downcast: downcastWidgetElement(editor),
      upcasts: {
        figure: function figure(element) {
          if ((!figureClass || element.hasClass(figureClass)) && element.find('img', true).length === 1) {
            if (isImageResizingEnabled && isControl(config.environment)) {
              var _element$styles;

              var isFloating = (_element$styles = element.styles) === null || _element$styles === void 0 ? void 0 : _element$styles.float;

              if (isFloating) {
                var align = element.styles.float;
                element.styles = {};
                element.attributes = {
                  align: align
                };
              }

              if (element.parent.styles && element.parent.styles['text-align'] === 'center') {
                element.parent.replaceWithChildren();
                element.attributes = {
                  align: 'center'
                };
              }
            }

            return element;
          }
        }
      }
    };

    if (editor.plugins.link) {
      widgetDefinition = CKEDITOR.plugins.imagebase.addFeature(editor, 'link', widgetDefinition);
    }

    widgetDefinition = CKEDITOR.plugins.imagebase.addFeature(editor, 'upload', widgetDefinition);
    widgetDefinition.progressReporterType = ProgressBar;

    if (!isEmailEditor(config.profile)) {
      widgetDefinition = CKEDITOR.plugins.imagebase.addFeature(editor, 'caption', widgetDefinition);
    }

    CKEDITOR.plugins.imagebase.addImageWidget(editor, WIDGET_NAME, widgetDefinition);
    editor.on('fileUploadRequest', function (evt) {
      imageCountsToProcess += 1;
      editor.fire('filesToProcessCountChange', {
        count: imageCountsToProcess,
        editor: editor
      });
      evt.stop();
      var _evt$data$fileLoader = evt.data.fileLoader,
          xhr = _evt$data$fileLoader.xhr,
          file = _evt$data$fileLoader.file,
          name = _evt$data$fileLoader.name;
      var tokenEl = document.getElementById('csrftoken');
      var form = new window.FormData();
      form.append('image', file, name);
      form.append('yip_csrf_token', tokenEl === null || tokenEl === void 0 ? void 0 : tokenEl.value);
      xhr.open('POST', (0, _absoluteUrlRuntime.resolveUrl)('/attachment/new'), true);
      xhr.send(form);
    });
    editor.on('fileUploadResponse', function (evt) {
      imageCountsToProcess -= 1;
      editor.fire('filesToProcessCountChange', {
        count: imageCountsToProcess,
        editor: editor
      });
      evt.stop();
      var response = JSON.parse(evt.data.fileLoader.xhr.responseText);
      evt.data.message = undefined;
      evt.data.url = response.source;
      evt.data.response = {
        default: response.source
      };
      evt.data.fileName = 'Image name';
    });
    editor.on('paste', function (evt) {
      if (!evt.data.dataValue.match(/<img[\s\S]+data:/i)) {
        return;
      }

      var data = evt.data;
      var tempDoc = document.implementation.createHTMLDocument('');
      var temp = new CKEDITOR.dom.element(tempDoc.body);
      temp.data('cke-editable', 1);
      temp.appendHtml(data.dataValue);
      var imgs = temp.find('img');

      for (var i = 0; i < imgs.count(); i++) {
        var img = imgs.getItem(i);
        var imgSrc = img.getAttribute('src'); // Only process images that contain src=data:...
        // If needed this could also be used to re-upload external images to our CDN

        var isDataInSrc = imgSrc && imgSrc.substring(0, 5) === 'data:';
        var isRealObject = img.data('cke-realelement') === null;
        var imgParent = img.getParent();

        if (isDataInSrc && isRealObject && !img.data('cke-upload-id') && !imgParent.data('cke-upload-id') && !img.isReadOnly(1)) {
          var _imgFormat;

          var imgFormat = imgSrc.match(/image\/([a-z]+?)/i);
          imgFormat = ((_imgFormat = imgFormat) === null || _imgFormat === void 0 ? void 0 : _imgFormat[1]) || 'jpg';
          var loader = editor.uploadRepository.create(imgSrc, getUniqueImageFileName(imgFormat));
          loader.upload('/attachment/new');
          var figure = new CKEDITOR.dom.element('figure');
          figure.setAttribute('class', 'image image-loading');
          figure.replace(img);
          figure.append(img);
          fileTools.markElement(img, 'imageupload', loader.id);
          fileTools.bindNotifications(editor, loader);
        }
      }

      data.dataValue = temp.getHtml();
    });
  }
};
var alignmentsObj = {
  left: 0,
  center: 1,
  right: 2
}; // Defines all features related to drag-driven image resizing.
//
// @param {CKEDITOR.plugins.widget} widget

function setupResizer(widget) {
  var editor = widget.editor;
  var editable = editor.editable();
  var doc = editor.document; // Store the resizer in a widget for testing (https://dev.ckeditor.com/ticket/11004).

  var resizer = widget.resizer = doc.createElement('span');
  resizer.addClass('cke_image_resizer');
  resizer.setAttribute('title', 'Drag to resize');
  resizer.append(new window.CKEDITOR.dom.text("\u200B", doc)); // Inline widgets don't need a resizer wrapper as an image spans the entire widget.

  if (!widget.inline) {
    var imageOrLink = widget.parts.image || widget.parts.link;
    var oldResizeWrapper = imageOrLink.getParent();
    var resizeWrapper = doc.createElement('span');
    resizeWrapper.addClass('cke_image_resizer_wrapper');
    resizeWrapper.append(imageOrLink);
    resizeWrapper.append(resizer);
    widget.element.append(resizeWrapper, true); // Remove the old wrapper which could came from e.g. pasted HTML
    // and which could be corrupted (e.g. resizer span has been lost).

    if (oldResizeWrapper.is('span')) {
      oldResizeWrapper.remove();
    }
  } else {
    widget.wrapper.append(resizer);
  } // Calculate values of size variables and mouse offsets.


  resizer.on('mousedown', function (evt) {
    var image = widget.parts.image; // Don't update attributes if less than 15.
    // This is to prevent images to visually disappear.

    var min = {
      width: 15,
      height: 15
    };
    var max = getMaxSize(); // "factor" can be either 1 or -1. I.e.: For right-aligned images, we need to
    // subtract the difference to get proper width, etc. Without "factor",
    // resizer starts working the opposite way.

    var factor = widget.data.align === 'right' ? -1 : 1; // The x-coordinate of the mouse relative to the screen
    // when button gets pressed.

    var startX = evt.data.$.screenX;
    var startY = evt.data.$.screenY; // The initial dimensions and aspect ratio of the image.

    var startWidth = image.$.clientWidth;
    var startHeight = image.$.clientHeight;
    var ratio = startWidth / startHeight;
    var listeners = []; // A class applied to editable during resizing.

    var cursorClass = 'cke_image_s' + (!~factor ? 'w' : 'e');
    var nativeEvt;
    var newWidth;
    var newHeight;
    var updateData;
    var moveDiffX;
    var moveDiffY;
    var moveRatio; // Save the undo snapshot first: before resizing.

    editor.fire('saveSnapshot'); // Mousemove listeners are removed on mouseup.

    attachToDocuments('mousemove', onMouseMove, listeners); // Clean up the mousemove listener. Update widget data if valid.

    attachToDocuments('mouseup', onMouseUp, listeners); // The entire editable will have the special cursor while resizing goes on.

    editable.addClass(cursorClass); // This is to always keep the resizer element visible while resizing.

    resizer.addClass('cke_image_resizing'); // Attaches an event to a global document if inline editor.
    // Additionally, if classic (`iframe`-based) editor, also attaches the same event to `iframe`'s document.

    function attachToDocuments(name, callback, collection) {
      var globalDoc = window.CKEDITOR.document;
      var listeners = [];

      if (!doc.equals(globalDoc)) {
        listeners.push(globalDoc.on(name, callback));
      }

      listeners.push(doc.on(name, callback));

      if (collection) {
        for (var i = listeners.length; i--;) {
          collection.push(listeners.pop());
        }
      }
    } // Calculate with first, and then adjust height, preserving ratio.


    function adjustToX() {
      newWidth = startWidth + factor * moveDiffX;
      newHeight = Math.round(newWidth / ratio);
    } // Calculate height first, and then adjust width, preserving ratio.


    function adjustToY() {
      newHeight = startHeight - moveDiffY;
      newWidth = Math.round(newHeight * ratio);
    }

    function onMouseMove(evt) {
      nativeEvt = evt.data.$; // This is how far the mouse is from the point the button was pressed.

      moveDiffX = nativeEvt.screenX - startX;
      moveDiffY = startY - nativeEvt.screenY; // This is the aspect ratio of the move difference.

      moveRatio = Math.abs(moveDiffX / moveDiffY); // Left, center or none-aligned widget.

      if (factor === 1) {
        if (moveDiffX <= 0) {
          // Case: IV.
          if (moveDiffY <= 0) {
            adjustToX();
          } else {
            if (moveRatio >= ratio) {
              adjustToX();
            } else {
              adjustToY();
            }
          }
        } else {
          // Case: III.
          if (moveDiffY <= 0) {
            if (moveRatio >= ratio) {
              adjustToY();
            } else {
              adjustToX();
            }
          } else {
            adjustToY();
          }
        }
      } else {
        if (moveDiffX <= 0) {
          // Case: IV.
          if (moveDiffY <= 0) {
            if (moveRatio >= ratio) {
              adjustToY();
            } else {
              adjustToX();
            }
          } else {
            adjustToY();
          }
        } else {
          // Case: III.
          if (moveDiffY <= 0) {
            adjustToX();
          } else {
            if (moveRatio >= ratio) {
              adjustToX();
            } else {
              adjustToY();
            }
          }
        }
      }

      if (isAllowedSize(newWidth, newHeight)) {
        // Do not set the height to always resize the image proportionally
        updateData = {
          width: newWidth
        };
        image.setAttributes(updateData);
      }
    }

    function onMouseUp() {
      var l;

      while (l = listeners.pop()) {
        l.removeListener();
      } // Restore default cursor by removing special class.


      editable.removeClass(cursorClass); // This is to bring back the regular behaviour of the resizer.

      resizer.removeClass('cke_image_resizing');

      if (updateData) {
        widget.setData(updateData); // Save another undo snapshot: after resizing.

        editor.fire('saveSnapshot');
      } // Don't update data twice or more.


      updateData = false;
    }

    function getMaxSize() {
      var maxSize = editor.config.image2_maxSize;

      if (!maxSize) {
        return null;
      }

      maxSize = window.CKEDITOR.tools.copy(maxSize);
      var natural = window.CKEDITOR.plugins.image2.getNatural(image);
      maxSize.width = Math.max(maxSize.width === 'natural' ? natural.width : maxSize.width, min.width);
      maxSize.height = Math.max(maxSize.height === 'natural' ? natural.height : maxSize.height, min.width);
      return maxSize;
    }

    function isAllowedSize(width, height) {
      var isTooSmall = width < min.width || height < min.height;
      var isTooBig = max && (width > max.width || height > max.height);
      return !isTooSmall && !isTooBig;
    }
  }); // Change the position of the widget resizer when data changes.

  widget.on('data', function () {
    resizer[widget.data.align === 'right' ? 'addClass' : 'removeClass']('cke_image_resizer_left');
  });
} // Integrates widget alignment setting with justify
// plugin's commands (execution and refreshment).
// @param {CKEDITOR.editor} editor
// @param {String} value 'left', 'right', 'center' or 'block'


function alignCommandIntegrator(editor) {
  var execCallbacks = [];
  return function (value) {
    var command = editor.getCommand('justify' + value); // Most likely, the justify plugin isn't loaded.

    if (!command) {
      return;
    } // This command will be manually refreshed along with
    // other commands after exec.


    execCallbacks.push(function () {
      command.refresh(editor, editor.elementPath());
    });

    if (value in {
      right: 1,
      left: 1,
      center: 1
    }) {
      command.on('exec', function (evt) {
        var widget = getFocusedWidget(editor);

        if (widget) {
          widget.setData('align', value); // Once the widget changed its align, all the align commands
          // must be refreshed: the event is to be cancelled.

          for (var i = execCallbacks.length; i--;) {
            execCallbacks[i]();
          }

          evt.cancel();
        }
      });
    }

    command.on('refresh', function (evt) {
      var widget = getFocusedWidget(editor);
      var allowed = {
        right: 1,
        left: 1,
        center: 1
      };
      if (!widget) return;
      var state;

      if (widget.data.align === value) {
        state = window.CKEDITOR.TRISTATE_ON;
      } else if (value in allowed) {
        state = window.CKEDITOR.TRISTATE_OFF;
      } else {
        state = window.CKEDITOR.TRISTATE_DISABLED;
      }

      this.setState(state);
      evt.cancel();
    });
  };
}

function setWrapperAlign(widget, alignClasses) {
  var wrapper = widget.wrapper;
  var align = widget.data.align;
  var element = widget.element;
  var hasCaption = widget.data.hasCaption;

  if (alignClasses) {
    // Remove all align classes first.
    for (var i = 3; i--;) {
      wrapper.removeClass(alignClasses[i]);
    }

    if (align === 'center') {
      // Avoid touching non-captioned, centered widgets because
      // they have the class set on the element instead of wrapper
      if (hasCaption) {
        wrapper.addClass(alignClasses[1]);
      }
    } else if (align !== 'none') {
      wrapper.addClass(alignClasses[alignmentsObj[align]]);
    }
  } else {
    if (align === 'center') {
      if (hasCaption) {
        wrapper.setStyle('text-align', 'center');
      } else {
        wrapper.removeStyle('text-align');
      }

      wrapper.setStyle('text-align', 'center');
      element.setStyle('display', 'inline-block');
      wrapper.removeStyle('float');
      wrapper.removeStyle('margin-right');
      wrapper.removeStyle('margin-left');
    } else {
      if (align === 'none') {
        wrapper.removeStyle('float');
      } else {
        wrapper.setStyle('float', align);
      }

      if (align === 'left') {
        wrapper.setStyle('margin-right', '20px');
        wrapper.removeStyle('margin-left');
      } else if (align === 'right') {
        wrapper.setStyle('margin-left', '20px');
        wrapper.removeStyle('margin-right');
      }

      wrapper.removeStyle('text-align');
      element.removeStyle('display');
    }
  }
} // Returns a function which transforms the widget to the external format
// according to the current configuration.
//
// @param {CKEDITOR.editor}


function downcastWidgetElement(editor) {
  var alignClasses = editor.config.image2_alignClasses; // @param {CKEDITOR.htmlParser.element} el

  return function (el) {
    // In case of <a><img/></a>, <img/> is the element to hold
    // inline styles or classes (image2_alignClasses).
    var attrsHolder = el.name === 'a' ? el.getFirst() : el;
    var attrs = attrsHolder.attributes;
    var align = this.data.align; // De-wrap the image from resize handle wrapper.
    // Only block widgets have one.

    if (!this.inline) {
      var resizeWrapper = el.getFirst('span');

      if (resizeWrapper) {
        resizeWrapper.replaceWith(resizeWrapper.getFirst({
          img: 1,
          a: 1
        }));
      }
    }

    if (align && align !== 'none') {
      var styles = window.CKEDITOR.tools.parseCssText(attrs.style || ''); // When the widget is captioned (<figure>) and internally centering is done
      // with widget's wrapper style/class, in the external data representation,
      // <figure> must be wrapped with an element holding an style/class:
      //
      // <div style="text-align:center">
      //  <figure class="image" style="display:inline-block">...</figure>
      // </div>
      // or
      // <div class="some-center-class">
      //  <figure class="image">...</figure>
      // </div>
      //

      if (align === 'center' && el.name === 'figure') {
        el = el.wrapWith(new window.CKEDITOR.htmlParser.element('div', alignClasses ? {
          'class': alignClasses[1]
        } : {
          style: 'text-align:center'
        }));
      } else if (align in {
        left: 1,
        right: 1
      }) {
        if (alignClasses) {
          attrsHolder.addClass(alignClasses[alignmentsObj[align]]);
        } else {
          styles.float = align;
        }

        if (align === 'left') {
          styles['margin-right'] = '20px';
        } else if (align === 'right') {
          styles['margin-left'] = '20px';
        }
      } // Update element styles.


      if (!alignClasses && !window.CKEDITOR.tools.isEmpty(styles)) {
        attrs.style = window.CKEDITOR.tools.writeCssText(styles);
      }
    }

    return el;
  };
} // Returns the focused widget, if of the type specific for this plugin.
// If no widget is focused, `null` is returned.
//
// @param {CKEDITOR.editor}
// @returns {CKEDITOR.plugins.widget}


function getFocusedWidget(editor) {
  var widget = editor.widgets.focused || editor.widgets.selected;

  if (widget && (widget.name === 'image' || widget.name === 'insidedimage')) {
    return widget;
  }

  return null;
}

var _default = imageUploadPlugin;
exports.default = _default;